'use client'

import React from 'react'

interface Props {
  targetId: string;
  className?: string;
  children: React.ReactNode;
}

export default function SmoothScrollButton({ targetId, className, children }: Props) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <button onClick={handleClick} className={className}>
      {children}
    </button>
  );
}
